import { ThemeBorderRadiiKeys } from '@agria/theme/src/styles/tokens/borderRadii';
import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';
import { colors } from '@agria/theme/src/styles/tokens';

export type ButtonTokens = {
  disabledOpacity: string;
  disabledTextColor: ThemeColorsKeys;
  disabledBackgroundColor: ThemeColorsKeys;
  borderRadius: ThemeBorderRadiiKeys;
  focusVisible: string;
  focusValid: string;
  focusInvalid: string;
};

const tokens: ButtonTokens = {
  disabledOpacity: '0.5',
  disabledTextColor: 'utilityText',
  disabledBackgroundColor: 'brandTwo100',
  borderRadius: 'small',
  focusVisible: `${colors.systemFocus};`,
  focusValid: `${colors.systemFocusValid};`,
  focusInvalid: `${colors.systemFocusInvalid};`,
};

export default tokens;
